import range from "lodash/range";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { EmojiQuestionProps } from "../types";
import { EmojiRadioGroup } from "@/storybook-components/emoji-radio/emoji-radio";

export const EmojiQuestion = (props: EmojiQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    isDisabled,
    questionLabel,
    questionLabelType,
    layoutProps,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    contentLayoutProps,
    options = [],
    answerStackSpacing,
    handleChange,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    layoutProps,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  const getEmoji = {
    0: "VeryUnHappy",
    1: "UnHappy",
    2: "Neutral",
    3: "Happy",
    4: "VeryHappy"
  };
  const emojiRange = options.length === 3 ? range(1, 4) : range(0, 5);

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <EmojiRadioGroup
          id={questionId}
          isDisabled={isDisabled}
          handleChange={handleChange}
          value={answer}
          emojiGroup={options.map((option, index) => ({
            type: getEmoji[emojiRange[index]],
            id: option.id,
            note: option.name
          }))}
          labelProps={{ ...answerProps }}
          spacing={answerStackSpacing}
          groupLayoutProps={{ ...contentLayoutProps }}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
